import type { ProjectRoleType } from "./RoleTypes";

export const ProjectStatus = {
    Pending: 'Pending',
    Active: 'Active',
    Archived: 'Archived',
    Template: 'Template'
} as const;

export type ProjectStatusType = typeof ProjectStatus[keyof typeof ProjectStatus];

export interface Project {
    id: string; // Unique identifier for the project
    name: string; // Name of the project
    description?: string; // Optional description of the project
    status: ProjectStatusType
    createdAt: Date; // Timestamp when the project was created
    updatedAt: Date; // Timestamp when the project was last updated
    members: {
        userId: string; // ID of the user
        role: ProjectRoleType; // Role of the user in the project
        fullName: string; // Optional full name of the user
        email?: string | null; // Optional email address of the user
    }[]; // List of members in the project with their roles
    icon?: string; // Optional icon class for the project
    // Creator and modifier metadata
    createdBy?: string | null;
    lastModifiedBy?: string | null;
}
